import ControlService from './ControlService.js';

export default ControlService;